import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import Badge from 'react-bootstrap/Badge'
import { useNavigate } from 'react-router-dom'

import './Presupuesto.css'

const PRESUPUESTO_PAGADO = 2
const PRESUPUESTO_EN_PREPARACION = 3

const Presupuesto = ({ presupuesto, canAdministrate }) => {
  const [estado, setEstado] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    setEstado(
      presupuesto.idEstado === 0
        ? 'danger'
        : presupuesto.idEstado === 1
          ? 'warning'
          : presupuesto.idEstado === PRESUPUESTO_PAGADO
            ? 'success'
            : presupuesto.idEstado === PRESUPUESTO_EN_PREPARACION
              ? 'info'
              : null
    )
  }, [presupuesto.idEstado])

  return (
    <div
      className="row presupuesto-item"
      onClick={() =>
        navigate(`/Presupuesto/${presupuesto.idPresupuesto}`, {
          state: { canAdministrate }
        })
      }
    >
      <div className="col presupuestoContent">
        <div className="presupuesto-header">
          <span className="presupuesto-titulo">{presupuesto.titulo}</span>

          <Badge bg={estado} className="presupuesto-badge">
            {presupuesto.estado}
          </Badge>
        </div>

        <div className="presupuesto-mensaje">
          <i className="fa fa-comment no-leido" aria-hidden="true"></i>
          <span>{presupuesto.ultimoMensaje}</span>
        </div>
      </div>
    </div>
  )
}

Presupuesto.propTypes = {
  presupuesto: PropTypes.shape({
    idPresupuesto: PropTypes.number.isRequired,
    idEstado: PropTypes.number.isRequired,
    estado: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    toggleOn: PropTypes.bool,
    ultimoMensaje: PropTypes.string
  }).isRequired,
  canAdministrate: PropTypes.bool.isRequired
}

export default Presupuesto
